module.exports = __webpack_public_path__ + "static/media/onfire-icon.b6c5181c.png";